package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.filter
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.value
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLCanvasElement
import waldo.sankan.lineamunicipalkmp.model.TipificacionesRepositoryCEAD
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import kotlin.compareTo
import kotlin.js.Date
import kotlin.js.json
import kotlin.math.roundToInt

private fun Int.percentOf(total: Int): Int {
    if (this <= 0 || total <= 0) return 0
    return (this.toDouble() / total * 100).roundToInt()
}

@Composable
private fun StatCard(label: String, value: String, color: CSSColorValue = Color.black) {
    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); padding(16.px) } }) {
        Span({ style { fontSize(28.px); fontWeight("bold"); color(color) } }) { Text(value) }
        Span({ style { fontSize(14.px); color(Color("#666666")) } }) { Text(label) }
    }
}

@Composable
private fun EstadisticasFilterSection(
    uiState: AdminPanelUiState,
    onBack: () -> Unit,
    viewModel: AdminPanelViewModel
) {
    // Variables de estado locales para manejar los inputs de fecha
    var fechaInicioStr by remember { mutableStateOf("") }
    var fechaFinStr by remember { mutableStateOf("") }

    Div({
        style {
            display(DisplayStyle.Flex);
            flexDirection(FlexDirection.Row);
            gap(16.px);
            padding(12.px, 24.px);
            backgroundColor(Color("#F8F9FA"));
            borderRadius(12.px);
            marginBottom(32.px);
            property("box-shadow", "0 2px 4px rgba(0,0,0,0.05)");
            alignItems(AlignItems.Center);
            width(100.percent);
            boxSizing("border-box");
        }
    }) {
        B({ style { fontSize(18.px); color(Color("#1976D2")) } }) { 
            val contextText = if (uiState.filtroComunaEstadisticas == "TODAS") "Territorio Regional (TODAS)" else "Comuna: ${uiState.filtroComunaEstadisticas}"
            val periodText = if (uiState.filtroMesEstadisticasGenerales == "ANUAL") "Resumen Anual" else uiState.filtroMesEstadisticasGenerales
            Text("\uD83D\uDCCA An\u00E1lisis Detallado: $contextText | Periodo: $periodText") 
        }

        Div({ style { flex(1) } })
        
        // Botón de Exportación PDF
        Button(attrs = {
            onClick {
                js("""
                    var jsPDF = window.jspdf.jsPDF;
                    var doc = new jsPDF('p', 'mm', 'a4');
                    var element = document.getElementById('contenido-estadisticas');
                    
                    html2canvas(element, {
                        scale: 2,
                        useCORS: true,
                        logging: false,
                        backgroundColor: '#1976D2'
                    }).then(function(canvas) {
                        var imgData = canvas.toDataURL('image/png');
                        var imgProps = doc.getImageProperties(imgData);
                        var pdfWidth = doc.internal.pageSize.getWidth();
                        var pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                        
                        var heightLeft = pdfHeight;
                        var position = 0;
                        
                        doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                        heightLeft -= doc.internal.pageSize.getHeight();
                        
                        while (heightLeft >= 0) {
                            position = heightLeft - pdfHeight;
                            doc.addPage();
                            doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                            heightLeft -= doc.internal.pageSize.getHeight();
                        }
                        
                        doc.save('Estadisticas_Detalladas_LineaMunicipal.pdf');
                    });
                """)
            }
            style {
                padding(10.px, 20.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                backgroundColor(Color("#4CAF50")); borderRadius(8.px); cursor("pointer"); border(0.px)
            }
        }) { Text("Exportar PDF") }

        Button(attrs = {
            onClick { onBack() }
            style {
                padding(10.px, 20.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                backgroundColor(Color("#FB8C00")); borderRadius(8.px); cursor("pointer"); border(0.px)
            }
        }) { Text("Volver Atr\u00E1s") }
    }
}


@Composable
fun EstadisticasSeguridadScreen(
    onBack: () -> Unit,
    viewModel: AdminPanelViewModel
) {
    val uiState by viewModel.uiState.collectAsState()
    val stats = uiState.estadisticasDelitos


    // --- VISTA PRINCIPAL DEL PANEL (TABLA E INCIDENCIAS) ---
    Div({
        style {
            display(DisplayStyle.Flex);
            width(100.percent);
            backgroundColor(Color("#1976D2"));
            property("border-bottom", "2px solid #1565C0")
        }
    }) {
        // Logo y Título
        Div({
            style {
                width(15.percent);
                display(DisplayStyle.Flex);
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center);
                padding(24.px);
                boxSizing("border-box")
            }
        }) {
            Div({
                style {
                    display(DisplayStyle.Flex);
                    flexDirection(FlexDirection.Column);
                    alignItems(AlignItems.Center);
                    gap(8.px) } }) {
                Img(src = "logo_icon.svg",
                    attrs = {
                        style { height(120.px) } })
                H2({
                    style { fontSize(24.px);
                        color(Color.white);
                        margin(0.px);
                        property("text-shadow",
                            "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                    Span({
                        style {
                            fontWeight("normal") } })
                    { Text("Linea") }
                    Span({
                        style {
                            fontWeight("bold") } })
                    { Text("Muni") }
                }
                P(attrs = { attr("translate", "no");
                    style { fontSize(16.px);
                        color(Color("#FB8C00"));
                        fontWeight("bold");
                        letterSpacing(1.px);
                        margin(0.px) } })
                { Text("SMART CITY") }
            }
        }

        // Panel de Control y Filtros
        Div({
            style {
                width(85.percent);
                padding(16.px, 24.px);
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column);
                gap(16.px);
                boxSizing("border-box")
            }
        }) {
            val rolUpperHeader = (uiState.rolAdmin?.rol ?: "").uppercase().trim()
            val prefix = if (rolUpperHeader == "GENERAL") "GENERALES" else "COMUNALES"
            val titleText = if (uiState.modoServiciosUrbanos) {
                "ESTAD\u00CDSTICAS $prefix SERVICIOS URBANOS"
            } else {
                "ESTAD\u00CDSTICAS $prefix SEGURIDAD CIUDADANA"
            }

            H1({
                style {
                    color(Color.white);
                    fontSize(32.px);
                    fontWeight(700);
                    margin(0.px);
                    paddingTop(20.px);
                    flex(1);
                    textAlign("center")
                }
            }) {
                Text(titleText)
            }

            EstadisticasFilterSection(uiState = uiState, onBack = onBack, viewModel = viewModel)
        }
    }

    // --- CONTENIDO PRINCIPAL ---
    Div({
        id("contenido-estadisticas") // ID para la exportación PDF
        style {
            paddingRight(32.px);
            paddingLeft(32.px);
            backgroundColor(Color("#1976D2"));
        }
    }) {

        if (uiState.isLoading) {
            P { Text("Calculando estad\u00EDsticas...") }
        } else if (stats == null) {
            Div({
                style {
                    padding(24.px);
                    textAlign("center");
                    backgroundColor(Color("#1976D2"));
                    borderRadius(12.px) } }) {
                P { Text("No se encontraron delitos para el per\u00EDodo seleccionado.") }
            }
        } else {
            val totalDelitos = stats.desglosePorGrupo.values.sumOf { it.total }
            val adminProfile = uiState.rolAdmin
            val rolUpper = (adminProfile?.rol ?: "").uppercase().trim()
            val rolesDAO = listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO")

            val esSeguridad = rolUpper == "SEGURIDAD_ADMIN"
            val esDao = uiState.modoServiciosUrbanos || rolUpper in rolesDAO || adminProfile?.comunaAsignadaDisplayName?.uppercase()?.contains("DAO") == true

            val labelHallazgo = if (esDao) "Incidencia" else "Hallazgo"
            val labelSolucion = if (esDao) "Soluci\u00F3n" else "Resoluci\u00F3n"
            val labelItem = if (esDao) "Incidencia" else "Delito"
            val labelSolucionado = if (esDao) "Solucionada" else "Solucionado"
            val labelSolucionadas = if (esDao) "Solucionadas" else "Solucionados"

            val cantidadItems = stats.desglosePorDelito.filter { it.value.total > 0 }.size

            val alturaBarraGrupos = if (esSeguridad) 500.px else 300.px
            val anchoBarraGrupos = if (esSeguridad) 100.percent else 70.percent
            
            Div({
                style {
                    backgroundColor(Color("#1976D2"));
                    borderRadius(12.px);
                    paddingBottom(32.px);
                    property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)") } }) {

                H2({
                    style {
                        fontSize(24.px);
                        color(Color.white);
                        marginTop(0.px);
                        marginBottom(24.px);
                        property("border-bottom", "1px solid #e0e0e0");
                        paddingBottom(16.px) } }) {
                    val periodoSeleccionado = uiState.filtroMesEstadisticas?.let { mes ->
                        if (mes == "ANUAL") "Resumen Anual"
                        else {
                            val (year, month) = mes.split("-")
                            Date(year.toInt(), month.toInt() - 1).toLocaleString("es-CL", options = js("{'month': 'long', 'year': 'numeric'}")).capitalize()
                        }
                    } ?: "Estad\u00EDsticas"
                    Text(periodoSeleccionado)
                }

                Div({
                    style {
                        display(DisplayStyle.Flex);
                        justifyContent(JustifyContent.SpaceAround);
                        alignItems(AlignItems.Center);
                        padding(32.px);
                        backgroundColor(Color("#fafafa"));
                        borderRadius(8.px);
                        marginBottom(24.px) } }) {
                    StatCard("Total", stats.resumenGeneral.total.toString())
                    StatCard("Solucionadas", stats.resumenGeneral.solucionado.toString(), Color("#4CAF50"))
                    StatCard("En Proceso", stats.resumenGeneral.enProceso.toString(), Color("#FFC107"))
                    StatCard("Rechazadas", stats.resumenGeneral.rechazado.toString(), Color("#F44336"))
                    StatCard("Verificadas", stats.resumenGeneral.verificado.toString(), Color("#3F51B5"))
                }
            }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(24.px)
                }
            }) {

                Div({
                    style {
                        backgroundColor(Color.white)
                        borderRadius(12.px)
                        padding(24.px)
                        property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)")
                    }
                }) {
                    H2({ style { fontSize(24.px); color(Color("#1976D2")); marginTop(0.px); marginBottom(24.px); property("border-bottom", "1px solid #e0e0e0"); paddingBottom(16.px) } }) {
                        Text("Resumen por Cantidades")
                    }

                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Row)
                            gap(24.px)
                            alignItems(AlignItems.Start)
                        }
                    }) {
                        Div({ style { flexBasis(40.percent) } }) {
                            Table({ style { width(100.percent); property("border-collapse", "collapse"); fontSize(14.px) } }) {
                                Thead({ style { backgroundColor(Color("#eef2f5")) } }) {
                                    Tr {
                                        val labelColumna = if (esDao) "Tipo de $labelHallazgo" else "Grupo"

                                        Th({ style { padding(12.px); textAlign("left"); width(25.percent) } }) { Text(labelColumna) }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("Total") }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent); color(Color("#4CAF50")) } }) { Text(labelSolucionadas) }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent); color(Color("#FFC107")) } }) { Text("En Proceso") }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent); color(Color("#F44336")) } }) { Text("Rechazadas") }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent); color(Color("#3F51B5")) } }) { Text("Verificadas") }
                                    }
                                }
                                Tbody {
                                    stats.desglosePorGrupo.entries.sortedByDescending { it.value.total }.forEach { (grupo, desglose) ->
                                        Tr {
                                            Td({ style { padding(12.px); fontWeight(700); width(25.percent) } }) {
                                                val displayGrupo = when(val g = grupo.uppercase().trim()) {
                                                    "AUTO_ABANDONADO", "AUTOS ABANDONADOS" -> "Autos Abandonados"
                                                    "ILUMINACION" -> "Iluminaci\u00F3n"
                                                    "SEMAFORO" -> "Sem\u00E1foros"
                                                    "BASURA" -> "Basura"
                                                    "BACHE", "BACHES" -> "Baches"
                                                    "SALVAVIDAS" -> "Salvavidas"
                                                    else -> grupo
                                                }
                                                Text(displayGrupo)
                                            }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text(desglose.total.toString()) }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text(desglose.solucionado.toString()) }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text(desglose.enProceso.toString()) }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text(desglose.rechazado.toString()) }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text(desglose.verificado.toString()) }
                                        }
                                    }
                                }
                            }
                        }

                        Div({
                            style {
                                flexBasis(60.percent)
                                display(DisplayStyle.Flex)
                                flexDirection(FlexDirection.Row)
                                gap(32.px)
                            }
                        }) {
                            Div({
                                style {
                                    flex(1)
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Column);
                                    alignItems(AlignItems.Center);
                                    gap(16.px);
                                    width(100.percent)
                                }
                            }) {
                                H3({ style { fontSize(18.px); color(Color("#333333")); margin(0.px) } }) { Text("Distribuci\u00F3n de Estados") }
                                Div({
                                    style {
                                        width(100.percent);
                                        height(alturaBarraGrupos);
                                        position(Position.Relative)
                                    }
                                }) {
                                    Canvas(attrs = { id("pieChart-Estados-Global") })
                                    DisposableEffect(stats) {
                                        val canvas = document.getElementById("pieChart-Estados-Global") as? HTMLCanvasElement
                                        var chart: dynamic = null
                                        if (canvas != null) {
                                            val resumen = stats.resumenGeneral
                                            val data = json(
                                                "labels" to arrayOf(labelSolucionadas, "En Proceso", "Rechazadas", "Verificadas"),
                                                "datasets" to arrayOf(json(
                                                    "data" to arrayOf(resumen.solucionado, resumen.enProceso, resumen.rechazado, resumen.verificado),
                                                    "backgroundColor" to arrayOf("#4CAF50", "#FFC107", "#F44336", "#3F51B5")
                                                ))
                                            )
                                            val options = json(
                                                "responsive" to true,
                                                "maintainAspectRatio" to false,
                                                "plugins" to json(
                                                    "legend" to json(
                                                        "position" to "bottom",
                                                        "labels" to json("padding" to 20, "usePointStyle" to true)
                                                    )
                                                )
                                            )
                                            chart = js("new Chart(canvas, { type: 'pie', data: data, options: options })")
                                        }
                                        onDispose { chart?.destroy() }
                                    }
                                }
                            }

                            Div({
                                style {
                                    flex(1);
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Column);
                                    alignItems(AlignItems.Center);
                                    gap(16.px);
                                    width(100.percent)
                                }
                            }) {
                                H3({
                                    style {
                                        fontSize(18.px);
                                        color(Color("#333333"));
                                        margin(0.px) } })
                                { Text("Composici\u00F3n") }
                                Div({
                                    style {width(100.percent)
                                        height(alturaBarraGrupos)
                                        position(Position.Relative)
                                    }
                                }) {
                                    Canvas(attrs = { id("barChart-Grupos-Cantidades") })
                                    DisposableEffect(stats) {
                                        val canvas = document.getElementById("barChart-Grupos-Cantidades") as? HTMLCanvasElement
                                        var chart: dynamic = null
                                        if (canvas != null) {
                                            val labels = stats.desglosePorGrupo.keys.toTypedArray()
                                            val chartData = json("labels" to labels, "datasets" to arrayOf(
                                                json("label" to labelSolucionadas, "data" to stats.desglosePorGrupo.map { it.value.solucionado }.toTypedArray(), "backgroundColor" to "#4CAF50"),
                                                json("label" to "En Proceso", "data" to stats.desglosePorGrupo.map { it.value.enProceso }.toTypedArray(), "backgroundColor" to "#FFC107"),
                                                json("label" to "Rechazadas", "data" to stats.desglosePorGrupo.map { it.value.rechazado }.toTypedArray(), "backgroundColor" to "#F44336"),
                                                json("label" to "Verificadas", "data" to stats.desglosePorGrupo.map { it.value.verificado }.toTypedArray(), "backgroundColor" to "#3F51B5")
                                            ))
                                            val options = json(
                                                "responsive" to true,
                                                "maintainAspectRatio" to false,
                                                "scales" to json("x" to json("stacked" to true, "ticks" to json("precision" to 0))),
                                                "y" to json("stacked" to true),
                                                "plugins" to json(
                                                    "legend" to json(
                                                        "position" to "bottom",
                                                        "labels" to json("padding" to 20, "usePointStyle" to true)
                                                    )
                                                )
                                            )
                                            chart = js("new Chart(canvas, { type: 'bar', data: chartData, options: options })")
                                        }
                                        onDispose { chart?.destroy() }
                                    }
                                }
                            }
                        }
                    }
                }

                Div({
                    style {
                        backgroundColor(Color.white)
                        borderRadius(12.px)
                        padding(24.px)
                        property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)")
                    }
                }) {
                    H2({
                        style {
                            fontSize(24.px);
                            color(Color("#1976D2"));
                            marginTop(0.px);
                            marginBottom(24.px);
                            property("border-bottom", "1px solid #e0e0e0"); paddingBottom(16.px) } }) {
                        Text("An\u00E1lisis por Porcentaje de Cumplimiento")
                    }

                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Row)
                            gap(24.px)
                            alignItems(AlignItems.Start)
                        }
                    }) {
                        Div({ style { flexBasis(40.percent) } }) {
                            Table({ style { width(100.percent); property("border-collapse", "collapse"); fontSize(14.px) } }) {
                                Thead({ style { backgroundColor(Color("#eef2f5")) } }) {
                                    Tr {
                                        Th({ style { padding(12.px); textAlign("left"); width(25.percent) } }) { Text(if (esDao) "Familia" else "Grupo") }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("% del Total") }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("% En Proceso") }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("% $labelSolucionado") }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("% Rechazado") }
                                        Th({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("% Verificado") }
                                    }
                                }
                                Tbody {
                                    stats.desglosePorGrupo.entries.sortedByDescending { it.value.total }.forEach { (grupo, desglose) ->
                                        Tr {
                                            Td({ style { padding(12.px); fontWeight(700); width(25.percent) } }) { Text(grupo) }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.total.percentOf(totalDelitos)}%") }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.enProceso.percentOf(desglose.total)}%") }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.solucionado.percentOf(desglose.total)}%") }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.rechazado.percentOf(desglose.total)}%") }
                                            Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.verificado.percentOf(desglose.total)}%") }
                                        }
                                    }
                                }
                            }
                        }

                        Div({
                            style {
                                flexBasis(60.percent)
                                display(DisplayStyle.Flex)
                                flexDirection(FlexDirection.Row)
                                gap(32.px)
                            }
                        }) {
                            Div({
                                style {
                                    flex(1);
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Column);
                                    alignItems(AlignItems.Center);
                                    gap(16.px);
                                    width(100.percent)
                                }
                            }) {
                                H3({
                                    style {
                                        fontSize(18.px);
                                        color(Color("#333333"));
                                        margin(0.px)
                                    }
                                }) { Text("Distribuci\u00F3n (%)") }

                                Div({
                                    style {
                                        width(100.percent);
                                        height(alturaBarraGrupos);
                                        position(Position.Relative)
                                    }
                                }) {
                                    Canvas(attrs = { id("pieChart-Grupos-Porcentajes") })
                                    DisposableEffect(stats) {
                                        val canvas = document.getElementById("pieChart-Grupos-Porcentajes") as? HTMLCanvasElement
                                        var chart: dynamic = null
                                        if (canvas != null) {
                                            val etiquetas = stats.desglosePorGrupo.keys.toTypedArray()
                                            val colorPalette = arrayOf(
                                                "#1976D2", "#388E3C", "#FBC02D", "#D32F2F", "#7B1FA2",
                                                "#9C27B0", "#03A9F4", "#E91E63", "#4CAF50", "#FFC107"
                                            )
                                            val backgroundColors = etiquetas.mapIndexed { index, _ ->
                                                colorPalette[index % colorPalette.size]
                                            }.toTypedArray()

                                            val data = json(
                                                "labels" to etiquetas,
                                                "datasets" to arrayOf(json(
                                                    "data" to stats.desglosePorGrupo.map { it.value.total.percentOf(totalDelitos) }.toTypedArray(),
                                                    "backgroundColor" to backgroundColors
                                                ))
                                            )
                                            val options = json(
                                                "responsive" to true,
                                                "maintainAspectRatio" to false,
                                                "plugins" to json(
                                                    "legend" to json(
                                                        "position" to "bottom",
                                                        "labels" to json("padding" to 20, "usePointStyle" to true)
                                                    )
                                                )
                                            )
                                            chart = js("new Chart(canvas, { type: 'pie', data: data, options: options })")
                                        }
                                        onDispose { chart?.destroy() }
                                    }
                                }
                            }

                            Div({
                                style {
                                    flex(1);
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Column);
                                    alignItems(AlignItems.Center);
                                    gap(16.px);
                                    width(100.percent)
                                }
                            }) {
                                H3({
                                    style {
                                        fontSize(18.px);
                                        color(Color("#333333"));
                                        margin(0.px)
                                    }
                                })
                                { Text("Cumplimiento (%)") }
                                Div({
                                    style {width(100.percent)
                                        height(alturaBarraGrupos)
                                        position(Position.Relative)
                                    }
                                }) {
                                    Canvas(attrs = { id("barChart-Grupos-Porcentajes") })
                                    DisposableEffect(stats) {
                                        val canvas = document.getElementById("barChart-Grupos-Porcentajes") as? HTMLCanvasElement
                                        var chart: dynamic = null
                                        if (canvas != null) {
                                            val labels = stats.desglosePorGrupo.keys.toTypedArray()
                                            val chartData = json("labels" to labels, "datasets" to arrayOf(
                                                json("label" to labelSolucionado, "data" to stats.desglosePorGrupo.map { it.value.solucionado.percentOf(it.value.total) }.toTypedArray(), "backgroundColor" to "#4CAF50"),
                                                json("label" to "En Proceso", "data" to stats.desglosePorGrupo.map { it.value.enProceso.percentOf(it.value.total) }.toTypedArray(), "backgroundColor" to "#FFC107"),
                                                json("label" to "Rechazado", "data" to stats.desglosePorGrupo.map { it.value.rechazado.percentOf(it.value.total) }.toTypedArray(), "backgroundColor" to "#F44336"),
                                                json("label" to "Verificado", "data" to stats.desglosePorGrupo.map { it.value.verificado.percentOf(it.value.total) }.toTypedArray(), "backgroundColor" to "#3F51B5")
                                            ))
                                            val options = json(
                                                "responsive" to true,
                                                "maintainAspectRatio" to false,
                                                "scales" to json("x" to json("stacked" to true, "ticks" to json("precision" to 0))),
                                                "y" to json("stacked" to true),
                                                "plugins" to json(
                                                    "legend" to json(
                                                        "position" to "bottom",
                                                        "labels" to json("padding" to 20, "usePointStyle" to true)
                                                    )
                                                )
                                            )
                                            chart = js("new Chart(canvas, { type: 'bar', data: chartData, options: options })")
                                        }
                                        onDispose { chart?.destroy() }
                                    }
                                }
                            }
                        }
                    }
                }

                Div({
                    style {
                        backgroundColor(Color.white); borderRadius(12.px); padding(24.px);
                        property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)")
                    }
                }) {
                    H2({
                        style {
                            fontSize(24.px); color(Color("#1976D2"));
                            marginTop(0.px); marginBottom(24.px);
                            property("border-bottom", "1px solid #e0e0e0");
                            paddingBottom(16.px)
                        }
                    }) {
                        Text("An\u00E1lisis Detallado por Tipificaci\u00F3n")
                    }
                    Div({
                        style {
                            display(DisplayStyle.Flex); gap(24.px);
                            alignItems(AlignItems.Stretch)
                        }
                    }) {
                        Div({
                            style { flex(1) }
                        }) {
                            Div({
                                style {
                                    maxHeight(800.px);
                                    overflowY("auto")
                                }
                            }) {
                                Table({
                                    style {
                                        width(100.percent);
                                        property("border-collapse", "collapse");
                                        fontSize(14.px)
                                    }
                                }) {
                                    Thead({
                                        style { backgroundColor(Color("#eef2f5")) }
                                    }) {
                                        Tr {
                                            Th({ style { padding(12.px); textAlign("left"); width(25.percent) } }) { Text("Tipificaci\u00F3n") };
                                            Th({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("Total") };
                                            Th({ style { padding(12.px); textAlign("center"); width(15.percent); color(Color("#4CAF50")) } }) { Text(labelSolucionadas) };
                                            Th({ style { padding(12.px); textAlign("center"); width(15.percent); color(Color("#FFC107")) } }) { Text("En Proceso") };
                                            Th({ style { padding(12.px); textAlign("center"); width(15.percent); color(Color("#F44336")) } }) { Text("Rechazadas") };
                                            Th({ style { padding(12.px); textAlign("center"); width(15.percent); color(Color("#3F51B5")) } }) { Text("Verificadas") }
                                        }
                                    }
                                    Tbody {
                                        val delitosMostrados = stats.desglosePorDelito.entries.filter { it.value.total > 0 }.sortedByDescending { it.value.total }
                                        delitosMostrados.forEach { (delito, desglose) ->
                                            Tr {
                                                Td({ style { padding(12.px); fontWeight(700); width(25.percent) } }) { Text(delito) }
                                                Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.total} (${desglose.total.percentOf(totalDelitos)}%)") }
                                                Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.solucionado} (${desglose.solucionado.percentOf(desglose.total)}%)") }
                                                Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.enProceso} (${desglose.enProceso.percentOf(desglose.total)}%)") }
                                                Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.rechazado} (${desglose.rechazado.percentOf(desglose.total)}%)") }
                                                Td({ style { padding(12.px); textAlign("center"); width(15.percent) } }) { Text("${desglose.verificado} (${desglose.verificado.percentOf(desglose.total)}%)") }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        Div({
                            style {
                                flex(1);
                                display(DisplayStyle.Flex);
                                flexDirection(FlexDirection.Column);
                                alignItems(AlignItems.Center);
                                gap(16.px)
                            }
                        }) {
                            H3({
                                style {
                                    fontSize(18.px);
                                    color(Color("#333333"));
                                    margin(0.px)
                                }
                            }) { Text("Composici\u00F3n de Estados") }
                            Div({
                                style {
                                    width(anchoBarraGrupos)
                                    height(alturaBarraGrupos)
                                    position(Position.Relative)
                                    if (!esSeguridad) margin(0.px)
                                }
                            }) {
                                Canvas(attrs = { id("barChart-Delitos") })
                                DisposableEffect(stats) {
                                    val canvas = document.getElementById("barChart-Delitos") as? HTMLCanvasElement
                                    var chart: dynamic = null
                                    if (canvas != null) {
                                        val delitosMostrados = stats.desglosePorDelito.entries.filter { it.value.total > 0 }.sortedByDescending { it.value.total }.reversed()
                                        val labels = delitosMostrados.map { it.key }.toTypedArray()
                                        val chartData = json("labels" to labels, "datasets" to arrayOf(
                                            json("label" to labelSolucionado,
                                                "data" to delitosMostrados.map { it.value.solucionado }.toTypedArray(),
                                                "backgroundColor" to "#4CAF50"),
                                            json("label" to "En Proceso",
                                                "data" to delitosMostrados.map { it.value.enProceso }.toTypedArray(),
                                                "backgroundColor" to "#FFC107"),
                                            json("label" to "Rechazado",
                                                "data" to delitosMostrados.map { it.value.rechazado }.toTypedArray(),
                                                "backgroundColor" to "#F44336"),
                                            json("label" to "Verificado",
                                                "data" to delitosMostrados.map { it.value.verificado }.toTypedArray(),
                                                "backgroundColor" to "#3F51B5")
                                        ))
                                        val options = json(
                                            "responsive" to true,
                                            "maintainAspectRatio" to false,
                                            "indexAxis" to "y",
                                            "scales" to json("x" to json("stacked" to true, "ticks" to json("precision" to 0))),
                                            "plugins" to json(
                                                "title" to json("display" to true, "text" to "Composici\u00F3n por Tipificaci\u00F3n"),
                                                "legend" to json(
                                                    "position" to "bottom",
                                                    "labels" to json("padding" to 20, "usePointStyle" to true)
                                                )
                                            )
                                        )
                                        chart = js("new Chart(canvas, { type: 'bar', data: chartData, options: options })")
                                    }
                                    onDispose { chart?.destroy() }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
